<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">
            <h2>Payment Channels</h2>
            <div class="float-right" *ngIf="false">
              <button type="button" class="btn btn-outline-primary btn-sm" (click)="openDialog('createChannel')">
              <i class="fa fa-plus"></i> &nbsp;<span>New Payment Channel</span></button></div>
          </div>
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="loadingData"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive" *ngIf="showData">
              <table id="all-channels" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th>#</th>
                  <th>Payment Channel</th>
                  <th>Description</th>
                  <th>Status</th>
                  <th>Action</th>

                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th>#</th>
                  <th>Payment Channel</th>
                  <th>Description</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
                </tfoot>
                <tbody>

                <tr *ngFor="let channel of paymentChannel;let i = index;">

                  <td>{{ i + 1 }}</td>
                  <td>&nbsp;
                    {{ channel?.payment_channel }}
                  </td>
                  <td>{{ channel?.payment_channel_description }}</td>
                  <td>
                  <span *ngIf="channel?.is_active" class="badge badge-success">Active</span>
                  <span *ngIf="!channel?.is_active" class="badge badge-warning">Inactive</span>
                  </td>
                  <td>
                    <!--<button class="btn btn-sm btn-info" (click)="triggerEdit(channel)">Edit</button>&nbsp;
                    <button  class="btn btn-sm btn-danger" (click)="deleteChannel(channel)">Delete</button>&nbsp;
                    -->
                    <div *ngIf="channel?.payment_channel !== 'e-WALLET'">
                      <button  class="btn btn-sm btn-success" *ngIf="!channel?.is_active" (click)="makeChannel(true, channel)">Make Active</button>&nbsp;
                    <button  class="btn btn-sm btn-warning" *ngIf="channel?.is_active" (click)="makeChannel(false, channel)">Make Inactive</button>
                    </div>
                  </td>
                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

    </div>



  </div>
</div>




<!-- Manage Payment Channel Modal -->
<div class="modal fade" id="createChannel" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="title" id="defaultModalLabel">{{modal.title}}</h6>
      </div>
      <form class="form-auth-small" #signupForm="ngForm" (ngSubmit)="createChannel()">

        <div class="modal-body">

          <div class="form-group">
            <label for="payment_channel" class="control-label ">Payment Channel Name</label>
            <input type="text" class="form-control" placeholder="Payment Channel Name"
                   #payment_channel="ngModel"
                   id="payment_channel"
                   [(ngModel)]="channel.payment_channel" [ngModelOptions]="{standalone: true}" required>
            <div class="text-danger" *ngIf="payment_channel.errors && (payment_channel.dirty || payment_channel.touched)">
                  <span class="validation-message" [hidden]="!payment_channel.hasError('required')">
                    Payment Channel Name is required</span>
            </div>
          </div>

          <div class="form-group">
            <label for="payment_channel_description" class="control-label ">Payment Channel Description</label>
            <input type="text" class="form-control" placeholder="Payment Channel Description"
                   #payment_channel_description="ngModel"
                   id="payment_channel_description"
                   [(ngModel)]="channel.payment_channel_description" [ngModelOptions]="{standalone: true}" required>
            <div class="text-danger" *ngIf="payment_channel_description.errors && (payment_channel_description.dirty || payment_channel_description.touched)">
                  <span class="validation-message" [hidden]="!payment_channel_description.hasError('required')">
                    Payment Channel Description is required</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" *ngIf="!loaders.saving" [disabled]="payment_channel.errors || payment_channel_description.errors" class="btn btn-primary">{{modal.btnText}}</button>
          <span *ngIf="loaders.saving" class="btn btn-primary">Loading&nbsp;<i class="fa fa-spin fa-spinner"></i></span>
          <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="resetForm()">CLOSE</button>
        </div>
      </form>
    </div>
  </div>
</div>


